import { createContext } from 'react'

export default createContext({ count: 0 })
